var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offline-indicator-container"},[_c('span',{staticClass:"offline-indicator"},[_vm._v("\n    You are no longer online.\n  ")])])}]

export { render, staticRenderFns }